<template>
    <div class="container">
        <el-form size="mini" :inline="true" label-position="left" :model="queryForm" ref="queryForm">
            <el-form-item label="公司名称" prop="commercial_id" v-if="commercials.length > 0">
                <el-select v-model="queryForm.commercialId"
                           clearable
                           filterable
                           placeholder="全部"
                           v-if="commercials.length > 1">
                    <el-option
                            v-for="item in commercials"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                    </el-option>
                </el-select>
                <el-input type="text" :value="commercials[0].name" disabled v-if="commercials.length == 1"></el-input>
            </el-form-item>
            <el-form-item label="店铺名称" prop="shopId" v-if="shops.length > 0">
                <el-select
                        v-model="queryForm.shopId"
                        filterable
                        remote
                        clearable
                        :remote-method="remoteShopMethod"
                        placeholder="请输入店铺">
                    <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易时间:" prop="date">
                <el-date-picker size="small"
                                style="width: 250px;"
                                v-model="queryForm.dateRange"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="交易类型:" prop="type">
                <el-select v-model="queryForm.type" placeholder="请选择">
                    <el-option value="0" label="全部"></el-option>
                    <el-option value="1" label="校园卡"></el-option>
                    <el-option value="2" label="非校园卡"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" type="primary" @click="fetchData">查询</el-button>
                <el-button size="mini" @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb10">
            <el-button type="primary" size="mini" @click="printPDF">打印</el-button>
        </el-row>
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="4">
                    <p>销售订单总计</p>
                    <p class="red mt10">{{summary.actualOrderCount}}单</p>
                </el-col>
                <el-col :span="3">
                    <p>商户结算款总计</p>
                    <p class="red mt10">{{summary.sealAmount}}元</p>
                </el-col>
            </el-row>
        </el-card>
        <export-excel style="margin-right: 20px;" class="fl" :params="exportParams" :action="$apiUrl.checkBillTotalSchool" :target="'oc'" :field="field" :filename="filename" :fieldname="fieldName"></export-excel>
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="date"
                    label="时间"
                    width="200"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="schoolName"
                    label="学校名称"
                    width="200"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="commercialName"
                    label="公司名称"
                    width="200"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="shopName"
                    label="店铺名称"
                    width="150"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="type"
                    label="交易类型"
                    width="150"
                    :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==1">校园卡</span>
                    <span v-if="scope.row.type==2">非校园卡</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="actualOrderNum"
                    label="实际订单笔数（退款后）"
                    width="200"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="incomeAmount"
                    label="订单金额（退款后）"
                    width="200"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="serviceFee"
                    label="外卖服务费"
                    width=""
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="deliveryFee"
                    label="配送费"
                    width=""
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="commercialAmount"
                    width=""
                    label="商户结算款"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="alySubsidyTranslation"
                    width=""
                    label="平台优惠"
                    :show-overflow-tooltip="true">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    // import { getSchoolAndShop } from '~/mixins/getSchoolAndShop1'
    import moment from 'moment'
    import exportExcel from '~/components/exportExcel2.vue'
    export default {
        components: {exportExcel},
        name: "schoolTotalBill4",
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    schoolId: localStorage.getItem('schoolId'),
                    shopId: '',
                    dateRange: [],
                    commercialId: '',
                    type: '',
                    is_authneed: true,
                    for_report: true
                },
                // schools: JSON.parse(localStorage.getItem('manager_school')),
                // schoolList: [],
                tableData: [],//表格数据
                loading: false,//表格是否显示加载效果
                commercialList: [],
                //导出
                exportParams: {},
                filename: '校企对账汇总表',
                fieldName: ['时间','学校名称','公司名称','店铺名称','交易类型','实际订单笔数（退款后）','订单金额（退款后）','外卖服务费','配送费','商户结算款','平台优惠'],
                field: ['date','schoolName','commercialName','shopName','typeStr','actualOrderNum','incomeAmount','serviceFee','deliveryFee','commercialAmount','alySubsidyTranslation'],
                commercials: [],
                summary: {},
                shopList: [],
                shops: JSON.parse(localStorage.getItem('shops')),

            }
        },
        computed: {
            operation: function(){
                return this.$store.getters.operation
            }
        },
        created(){
            this.commercials = JSON.parse(localStorage.getItem('commercials'));
            //默认显示最近一周
            var day = new Date();
            // day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,day];
            this.fetchData();
        },
        methods: {
            fetchData() {
                let params = {...this.queryForm};
                if(params.dateRange && params.dateRange.length > 0){
                    params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
                    params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
                    delete params.dateRange;
                }else{
                    this.$message.warning('请选择预计打款时间');
                    return;
                }
                this.exportParams = {...params};
                this.loading = true;
                this.$apiJava.post(this.$apiUrl.checkBillTotalSchool,params,(res)=>{
                    this.loading = false;
                    this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.msg);
                    this.loading = false;
                    this.tableData = [];
                },'oc')
                this.$apiJava.post(this.$apiUrl.reconciliationBillSummary,params,(res)=>{
                    this.summary = res.data;
                },(res)=>{
                    this.$message.warning(res.msg);
                },'oc')
            },
            remoteShopMethod(query){
                if (query !== '') {
                    this.shopList = [];
                    var arr = [];
                    let len = this.shops.length;
                    var reg = new RegExp(query);
                    for(var i=0;i<len;i++){
                        //如果字符串中不包含目标字符会返回-1
                        if(this.shops[i].name.match(reg)){
                            this.shopList.push(this.shops[i]);
                        }
                    }
                } else {
                    this.shopList = [];
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                var day = new Date();
                day.setTime(day.getTime()-7*24*60*60*1000);
                this.queryForm.dateRange = [day,new Date()];
                this.queryForm.commercialId = '';
            },
            printPDF() {
                let hostStr = window.location.host;
                let host = hostStr.replace('e','oc');
                let url = location.protocol +'//'+ host + '/' + this.$apiUrl.schoolCompanyExportPDF + '?export=4&startDate=' + moment(this.queryForm.dateRange[0]).format('YYYYMMDD') + '&endDate=' + moment(this.queryForm.dateRange[1]).format('YYYYMMDD') + '&schoolId=' + this.queryForm.schoolId + '&shopId=' + this.queryForm.shopId + '&commercialId=' + this.queryForm.commercialId + '&type=' + this.queryForm.type + '&isShowSensitiveData=0';
                window.open(url);
            }

        }
    }
</script>

<style lang="scss"  scoped>
    .el-card{
        border: none;
        box-shadow: none;
    }
</style>



// WEBPACK FOOTER //
// schoolTotalBill4.vue?237640d8